import React from 'react';
import EditorAlignLeft from '@wix/da-ds/pkg/Icons/24x24/EditorAlignLeft';
import EditorAlignRight from '@wix/da-ds/pkg/Icons/24x24/EditorAlignRight';
import EditorAlignCenter from '@wix/da-ds/pkg/Icons/24x24/EditorAlignCenter';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';
const Alignment = ({ editor })=>{
    const { t } = useTranslation('editor');
    let CurrentIcon = EditorAlignLeft;
    if (editor.isActive('da-deviation', {
        alignment: 'right'
    })) {
        CurrentIcon = EditorAlignRight;
    }
    if (editor.isActive('da-deviation', {
        alignment: 'center'
    })) {
        CurrentIcon = EditorAlignCenter;
    }
    if (!editor.can().chain().focus().daDeviationAlign('center').run()) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "node:deviation:align",
        tooltipText: t('ext.deviation.toolbar.alignment'),
        "aria-label": t('ext.deviation.toolbar.alignment'),
        icon: CurrentIcon,
        items: [
            {
                featureId: 'node:deviation:alignLeft',
                label: t('ext.deviation.toolbar.alignment.left'),
                icon: /*#__PURE__*/ React.createElement(EditorAlignLeft, null),
                selected: editor.isActive('da-deviation', {
                    alignment: 'left'
                }),
                onClick: ()=>{
                    editor.chain().focus().daDeviationAlign('left').run();
                }
            },
            {
                featureId: 'node:deviation:alignCenter',
                label: t('ext.deviation.toolbar.alignment.center'),
                icon: /*#__PURE__*/ React.createElement(EditorAlignCenter, null),
                selected: editor.isActive('da-deviation', {
                    alignment: 'center'
                }),
                onClick: ()=>{
                    editor.chain().focus().daDeviationAlign('center').run();
                }
            },
            {
                featureId: 'node:deviation:alignRight',
                label: t('ext.deviation.toolbar.alignment.right'),
                icon: /*#__PURE__*/ React.createElement(EditorAlignRight, null),
                selected: editor.isActive('da-deviation', {
                    alignment: 'right'
                }),
                onClick: ()=>{
                    editor.chain().focus().daDeviationAlign('right').run();
                }
            }
        ]
    });
};
Alignment.displayName = 'Alignment';
export default Alignment;

//# sourceMappingURL=Alignment.js.map